import { Box } from "@mui/material";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Flex from "../../../../components/Flex";
import CustomTabs from "../../../../components/app/CustomTabs";

const TABS_DATA = [
  {
    value: "",
    label: "Orders",
  },
  {
    value: "reports",
    label: "Reports",
  },
];

const PatientPortalOrders = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab === "order" ? "" : (currentTab as string);
  });

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(tab);
  };

  return (
    <Box width={"100%"} height={"100%"}>
      <Flex mb={1}>
        <CustomTabs
          tabsData={TABS_DATA}
          value={activeTab}
          onChange={handleTabChange}
        />
      </Flex>
      <Outlet />
    </Box>
  );
};

export default PatientPortalOrders;
